export default {
  modules: {
    chat: true,
    inbox: true,
    medical: false,
    symptom: false,
    healhtips: false,
    profile: true,
    documents: true,
    emergency: false
  },
  practitioner: {
    type: 'lawyer',
    plural_type: 'lawyers'
  },
  app: {
    name: 'Legal Chief',
    endpoint: 'https://medi4u.co.za/legal/'
  },
  registration: {
    simple: true
  },
  permissions: [
    'android.permission.RECORD_AUDIO',
    'android.permission.WRITE_EXTERNAL_STORAGE',
    'android.permission.CAMERA',
  ],
  requiresLocation: false
}
